// this file was prevaled
module.exports={"name":"soapbox-fe","displayName":"Soapbox","url":"https://gitlab.com/soapbox-pub/soapbox-fe","repository":"soapbox-pub/soapbox-fe","version":"3.0.0-5f1d9ac","homepage":"https://soapbox.pub/"};